import { render, staticRenderFns } from "./CardComponent.vue?vue&type=template&id=4f57c2b9"
import script from "./CardComponent.vue?vue&type=script&lang=js"
export * from "./CardComponent.vue?vue&type=script&lang=js"
import style0 from "./CardComponent.vue?vue&type=style&index=0&id=4f57c2b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports